// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"237":"ScaffoldPage-TutorialPage","629":"TutorialPage","831":"ScaffoldPage"}[chunkId] + "." + {"237":"9727ffb1","629":"3b45fa06","831":"3b45fa06"}[chunkId] + ".chunk.css";
};